"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHOW_ADD_TO_COLLECTION_GA_ACTION = exports.CREATE_COLLECTION_VIEW_GA_ACTION = exports.REACHED_MAX_EVENTS_GA_ACTION = exports.REMOVE_FROM_COLLECTION_GA_ACTION = exports.ADD_TO_COLLECTION_GA_ACTION = exports.CREATE_COLLECTION_GA_ACTION = exports.COLLECTION_PROP_TYPE = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//This will match the output of the
//collection selector present in this duck.
var COLLECTION_PROP_TYPE = _propTypes.default.arrayOf(_propTypes.default.shape({
  eventCount: _propTypes.default.number,
  href: _propTypes.default.string,
  id: _propTypes.default.string,
  name: _propTypes.default.string
})); // GA TRACKING CONSTANTS


exports.COLLECTION_PROP_TYPE = COLLECTION_PROP_TYPE;
var CREATE_COLLECTION_GA_ACTION = 'CreateCollection';
exports.CREATE_COLLECTION_GA_ACTION = CREATE_COLLECTION_GA_ACTION;
var ADD_TO_COLLECTION_GA_ACTION = 'AddToCollection';
exports.ADD_TO_COLLECTION_GA_ACTION = ADD_TO_COLLECTION_GA_ACTION;
var REMOVE_FROM_COLLECTION_GA_ACTION = 'RemoveFromCollection';
exports.REMOVE_FROM_COLLECTION_GA_ACTION = REMOVE_FROM_COLLECTION_GA_ACTION;
var REACHED_MAX_EVENTS_GA_ACTION = 'CollectEventLimitReached';
exports.REACHED_MAX_EVENTS_GA_ACTION = REACHED_MAX_EVENTS_GA_ACTION;
var CREATE_COLLECTION_VIEW_GA_ACTION = 'CreateCollectionAttempt';
exports.CREATE_COLLECTION_VIEW_GA_ACTION = CREATE_COLLECTION_VIEW_GA_ACTION;
var SHOW_ADD_TO_COLLECTION_GA_ACTION = 'AddToCollectionListShown';
exports.SHOW_ADD_TO_COLLECTION_GA_ACTION = SHOW_ADD_TO_COLLECTION_GA_ACTION;
//# sourceMappingURL=constants.js.map